<template>
  <div id="homepage-sidebar">
    <div class="sidebar-header">
      <div class="sidebar-title">{{ sidebarTitle }}</div>
    </div>

    <div class="sidebar-content">
      <ShowroomPaths :activePath="activePath" v-on="{ handleSelectPath }" />
      <div class="path-information" v-if="pathInformation">
        {{ pathInformation }}
      </div>
      <template>
          <component
            :is="pathComponent"
            @personalizationsTabActive="handleUpdatePersonalizationsTab"
          />
      </template>
      <div class="locker-code-container">
        <p>
          Are you a returning user with a Locker Code?
          <strong @click="handleShowLocker()">CLICK HERE</strong>
        </p>
        <input
          name="locker-code"
          class="input-style form-control"
          v-show="showLockerCode"
          v-model="lockerCode"
          maxlength="10"
        />

        <button
          class="btn btn-black next-step"
          @click="goToLocker()"
          v-show="showLockerCode"
        >
          {{ loadingLocker ? "Loading..." : "Go to Locker" }}
        </button>
        <span v-if="loadingLockerError" class="error" v-show="showLockerCode">{{
          loadingLockerError
        }}</span>
      </div>
    </div>

    <!--   <div class="locker-code-container form-group" v-if="!selectedInstitution">
      <div class="input-group">
        <label>I have a Locker Code</label>
        <input class="input mb-1" v-model="lockerCode" />
        <span v-if="loadingLockerError" class="text-error">{{
          loadingLockerError
        }}</span>
      </div>
      <button class="btn btn-black next-step" @click="goToLocker()">
        {{ loadingLocker ? "Loading..." : "Go to Locker" }}
      </button>
    </div>-->
    <DecorationHiddenPlayer />
  </div>
</template>

<script>
import ShowroomPaths from "@/components/Projects/Showrooms/Homepage/ShowroomPaths";
import DecorationHiddenPlayer from "@/components/Projects/Showrooms/DecorationHiddenPlayer";

//paths
import SchoolsPath from "@/components/Projects/Showrooms/Homepage/SchoolsPath";
import TeamsPath from "@/components/Projects/Showrooms/Homepage/TeamsPath";
import OtherPath from "@/components/Projects/Showrooms/Homepage/OtherPath";

//import HomeSidebarStep1 from "@/components/Projects/Showrooms/Homepage/HomeSidebarStep1";
//import HomeSidebarStep2 from "@/components/Projects/Showrooms/Homepage/HomeSidebarStep2";
//import HomeSidebarStep3 from "@/components/Projects/Showrooms/Homepage/HomeSidebarStep3";

import { mapActions, mapState } from "vuex";

export default {
  name: "HomeSidebar",

  computed: {
    ...mapState("showroom", [
      "selectedInstitution",
      "selectedSchool",
      "mascot",
      "selectedInstitutionName",
    ]),

    ...mapState("lockerModule", ["loadingLocker", "loadingLockerError"]),

    hasInstitutionName() {
      return this.selectedInstitutionName?.trim()?.length > 0;
    },

    sidebarTitle() {
      return !this.activeTab
        ? "Tell us about yourself"
        : "Personalize Your Look";
    },

    pathInformation() {
      switch (this.activeTab) {
        case "personalizations":
          return "Tell us about your team so we can select the perfect gear for you";

        case "products":
          return "Great, now select the type of gear you'd like to shop for!";

        default:
          return false;
      }
    },

    mascotName() {
      if (this.selectedInstitutionIsSchool) {
        return this.mascot;
      }
      return this.selectedInstitutionName;
    },

    hasLockerCode() {
      return this.lockerCode.trim().length > 0;
    },

    //Paths

    pathComponent() {
      switch (this.activePath) {
        case "school":
          return "SchoolsPath";

        case "team":
          return "TeamsPath";

        default:
          return "OtherPath";
      }
    },
  },

  methods: {
    ...mapActions("showroom", [
      "selectInstitution",
      "selectSchool",
      "resetCatalogsSelection",
    ]),
    ...mapActions("lockerModule", ["getLockerByCode"]),
    ...mapActions("project", ["redirectToLocker"]),

    reset() {
      this.selectInstitution(null);
      this.selectSchool(null);
    },

    handleSelectInstitution(institution) {
      this.selectInstitution(institution);
    },

    /*handleSetSchool(school) {
      this.selectedSchool = school;
      this.handleUpdateSchoolKeyword(school.name);
      this.handleUpdateTeamName(school.name);
      this.handleSelectColor({
        field: "color_1",
        color: this.getColorById(school.color_1),
      });
      this.handleSelectColor({
        field: "color_2",
        color: this.getColorById(school.color_2),
      });
      this.handleSelectColor({
        field: "color_3",
        color: this.getColorById(school.color_3),
      });
    },*/

    async goToLocker() {
      if (this.hasLockerCode) {
        try {
          await this.getLockerByCode(this.lockerCode);
          if (!this.loadingLockerError) {
            this.redirectToLocker();
          }
        } catch (error) {
          console.log(error);
        }
      }
    },

    handleShowLocker() {
      this.showLockerCode = !this.showLockerCode;
    },

    //Paths

    handleSelectPath(payload) {
      this.activePath = payload.path;
    },

    //Tabs

    handleUpdatePersonalizationsTab(tab) {
      this.activeTab = tab;
    },
  },

  data() {
    return {
      lockerCode: "",
      activePath: "school",
      showLockerCode: false,
      activeTab: false,
    };
  },

  watch: {
    selectedInstitution() {
      this.resetCatalogsSelection();
    },
  },

  components: {
    ShowroomPaths,
    SchoolsPath,
    TeamsPath,
    OtherPath,
    DecorationHiddenPlayer,
    /*  HomeSidebarStep1,
    HomeSidebarStep2,
    HomeSidebarStep3,*/
  },
};
</script>

<style lang="scss">
#app {
  #homepage-sidebar {
    * {
      -webkit-user-select: none;
      -moz-user-select: none;
      -ms-user-select: none;
      user-select: none;
    }
    display: flex;
    flex-direction: column;
    width: 100%;
    min-width: 40%;
    max-width: 700px;
    //background: #ffffff;
    //box-shadow: 0px 9px 50px rgba(0, 0, 0, 0.2);
    //border-radius: 6px;

    .fade-enter-active,
    .fade-leave-active {
      transition: opacity 0.2s;
    }
    .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
      opacity: 0;
    }

    .sidebar-header {
      .sidebar-title {
        text-transform: uppercase;
        text-align: center;
        font-size: 34px;
        color: #000000;
        font-weight: bold;
        letter-spacing: 4px;
      }
    }

    .sidebar-content {
      padding: 1.5em 5em 5em;
      background: #ffffff;
      box-shadow: 0px 9px 50px rgba(0, 0, 0, 0.2);

      .path-information {
        display: flex;
        justify-content: center;
        align-items: center;
        background-color: #eef3ff;
        color: #6492f4;
        padding: 1em;
        border-radius: 1em;
        border: 1px solid #6492f4;
        margin: 1em -1em;
      }

      .btn-back {
        color: #6d7283;
        cursor: pointer;
        display: block;
        font-size: 16px;
        line-height: 19px;
        letter-spacing: 0em;
        margin: 10px 0;
        padding: 0.25rem;
        width: fit-content;

        &:hover {
          text-decoration: underline;
        }
      }
    }

    .path-navigation {
      display: flex;
      flex-direction: column;
      margin: 1em 0;
      width: 100%;
      align-items: center;

      .navigation-divider {
        width: 75%;
        border-top: 1px solid #e2e5ec;
      }

      .path-actions {
        display: flex;

        .path-hint {
          opacity: 0.3;
          padding: 0.3em 1em;
        }

        .path-action {
          padding: 0.3em 1em;
          color: white;
          background: black;
          border-radius: 5px;
          display: flex;
          align-items: center;
          cursor: pointer;

          &.path-action-disabled {
            cursor: not-allowed;
            opacity: 0.3;
          }

          svg {
            margin-left: 3px;
          }
        }
      }
    }

    .locker-code-container {
      margin-top: 2em;
      display: flex;
      flex-direction: column;
      align-items: center;
      strong {
        cursor: pointer;
      }

      .next-step {
        width: 100%;
        margin: 1em 0;
      }

      .error {
        color: red;
      }
    }
  }
}
</style>
